function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCoc = function SvgCoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 248.27 59.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.99,21.67c-1.11,1.11-2.62,1.75-4.13,1.75-1.33,0-2.56-.5-3.47-1.39l-13.69-13.7-1.24,1.24,4.73,4.73-15.33,15.33c-.45.45-.81.98-1.09,1.55-.42.9-.6,1.89-.52,2.87C2.21,29.96,0,24.77,0,19.43c0-5.1,2.04-9.94,5.72-13.6S14.29.15,19.49.15c3.07,0,6,.69,8.7,2.04,1.1.54,2.17,1.21,3.18,2l.48.37,9.51,9.5c1.98,2,1.82,5.41-.37,7.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.19,21.3l-15.33,15.32c-.72.71-2.21,1.63-3.23,1.63-1.09,0-2.14-.44-2.93-1.23s-1.23-1.83-1.23-2.93c0-1.03.39-1.99,1.11-2.71l15.85-15.85,5.76,5.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9,19.43c.01,5.37-2.24,10.59-6.34,14.69-2.44,2.43-5.24,5.24-8.11,8.11l-15.62,15.48c-.72.72-1.68,1.11-2.71,1.11-1.1,0-2.15-.44-2.93-1.23-.77-.77-1.21-1.79-1.23-2.86-.02-1.05.37-2.04,1.1-2.78l15.16-15.16-1.5-1.5-16.93,16.92c-.72.71-1.69,1.11-2.71,1.11-1.09,0-2.14-.44-2.93-1.23-.79-.8-1.23-1.83-1.23-2.93,0-1.03.39-1.99,1.11-2.71l16.92-16.94-1.71-1.71-17.43,17.41c-.72.72-1.68,1.11-2.71,1.11-1.1,0-2.15-.44-2.93-1.23-.77-.77-1.21-1.79-1.23-2.86-.03-1.05.37-2.04,1.1-2.78l16.64-16.64.47.47c1.24,1.23,2.91,1.91,4.7,1.91,1.96,0,3.91-.83,5.37-2.27,2.87-2.88,3.03-7.4.36-10.07l-7.46-7.47C38.75,2,43.44.15,48.4.15s10.07,2.02,13.77,5.68c3.68,3.66,5.72,8.5,5.73,13.6Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.79,53.94c0-1.39.5-2.57,1.49-3.54s2.2-1.46,3.63-1.46,2.65.49,3.65,1.47c.99.98,1.48,2.18,1.48,3.61s-.5,2.65-1.49,3.62c-1,.97-2.23,1.45-3.68,1.45s-2.65-.49-3.62-1.48c-.97-.97-1.46-2.19-1.46-3.67ZM67.06,53.98c0,.96.26,1.72.77,2.28.53.57,1.22.85,2.08.85s1.56-.28,2.08-.84c.52-.56.78-1.3.78-2.24s-.26-1.68-.78-2.24c-.53-.57-1.22-.85-2.08-.85s-1.54.28-2.06.85c-.52.57-.79,1.3-.79,2.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.66,51.28v7.54h-2.23v-7.54h-.79v-2.07h.79v-1.84c0-1.21.21-2.06.63-2.56.58-.7,1.42-1.04,2.52-1.04.4,0,.89.11,1.49.35v2.27l-.23-.12c-.48-.24-.87-.36-1.18-.36-.39,0-.66.14-.8.42s-.21.81-.21,1.6v1.29h2.42v2.07h-2.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.07,49.62v2.95c-.51-.62-.96-1.04-1.36-1.27-.39-.24-.86-.36-1.39-.36-.84,0-1.53.29-2.08.88s-.83,1.32-.83,2.2.27,1.64.8,2.22c.54.58,1.23.87,2.06.87.53,0,1-.11,1.41-.35.39-.22.86-.66,1.39-1.3v2.93c-.9.47-1.8.7-2.7.7-1.49,0-2.73-.48-3.73-1.44-1-.97-1.5-2.17-1.5-3.6s.51-2.64,1.52-3.63c1.01-.99,2.26-1.48,3.73-1.48.94,0,1.84.23,2.68.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.52,49.21h2.23v9.61h-2.23v-1.01c-.91.85-1.9,1.28-2.95,1.28-1.33,0-2.43-.48-3.29-1.44-.86-.98-1.29-2.2-1.29-3.67s.43-2.64,1.29-3.6,1.94-1.44,3.24-1.44c1.12,0,2.12.46,3.01,1.38v-1.11s-.01,0-.01,0ZM101.25,53.98c0,.92.25,1.67.74,2.25.51.58,1.14.88,1.91.88.82,0,1.49-.28,1.99-.85.51-.58.76-1.33.76-2.23s-.25-1.64-.76-2.23c-.51-.57-1.16-.86-1.97-.86-.76,0-1.4.29-1.91.87-.5.59-.76,1.31-.76,2.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.62,49.21h2.22v.86c.41-.43.77-.72,1.08-.88.32-.16.7-.25,1.14-.25.58,0,1.2.19,1.84.57l-1.02,2.03c-.42-.3-.83-.45-1.23-.45-1.21,0-1.81.91-1.81,2.74v4.98h-2.22v-9.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.75,54.53h-6.89c.06.79.32,1.42.77,1.88.45.46,1.04.69,1.75.69.55,0,1.01-.13,1.37-.39s.76-.75,1.21-1.46l1.87,1.05c-.29.49-.59.92-.92,1.27-.32.35-.67.64-1.04.87s-.77.39-1.19.5c-.43.1-.89.16-1.39.16-1.43,0-2.58-.46-3.45-1.38-.87-.93-1.3-2.16-1.3-3.69s.42-2.75,1.26-3.69c.85-.93,1.97-1.39,3.37-1.39s2.53.45,3.35,1.35c.82.9,1.22,2.13,1.22,3.72v.51ZM125.47,52.72c-.31-1.18-1.06-1.78-2.24-1.78-.27,0-.52.04-.76.12s-.45.2-.65.36c-.19.15-.36.34-.5.56s-.24.46-.32.74c0,0,4.47,0,4.47,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.21,49.21h2.22v.86c.41-.43.77-.72,1.08-.88.32-.16.7-.25,1.14-.25.58,0,1.2.19,1.84.57l-1.02,2.03c-.42-.3-.83-.45-1.23-.45-1.21,0-1.81.91-1.81,2.74v4.98h-2.22v-9.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.37,50.85l-1.84.98c-.29-.59-.65-.89-1.07-.89-.2,0-.38.07-.52.2s-.22.31-.22.52c0,.37.43.73,1.28,1.09,1.18.51,1.97.97,2.38,1.4s.61,1,.61,1.73c0,.93-.34,1.7-1.03,2.33-.66.59-1.47.89-2.41.89-1.61,0-2.75-.79-3.42-2.36l1.89-.88c.26.46.46.75.6.88.27.25.59.37.97.37.75,0,1.12-.34,1.12-1.03,0-.4-.29-.76-.87-1.11-.22-.11-.45-.22-.67-.33-.22-.1-.45-.21-.68-.32-.64-.32-1.1-.63-1.36-.95-.34-.4-.5-.92-.5-1.55,0-.83.29-1.52.86-2.07.58-.55,1.3-.82,2.13-.82,1.23.01,2.15.65,2.75,1.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.88,45.21c0-.39.14-.72.42-1.01.28-.28.62-.42,1.02-.42s.74.14,1.03.42c.28.28.42.62.42,1.02s-.14.74-.42,1.03c-.28.28-.62.42-1.02.42s-.74-.14-1.03-.42c-.28-.28-.42-.63-.42-1.04ZM154.43,49.21v9.61h-2.22v-9.61h2.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.32,49.21h2.23v.89c.78-.77,1.65-1.15,2.62-1.15,1.12,0,1.99.35,2.62,1.06.54.6.81,1.57.81,2.93v5.89h-2.23v-5.37c0-.95-.13-1.6-.4-1.96-.26-.37-.72-.55-1.4-.55-.74,0-1.26.24-1.57.73-.3.48-.45,1.32-.45,2.51v4.64h-2.23v-9.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.22,50.85l-1.84.98c-.29-.59-.65-.89-1.07-.89-.21,0-.38.07-.52.2s-.22.31-.22.52c0,.37.43.73,1.28,1.09,1.18.51,1.97.97,2.38,1.4s.61,1,.61,1.73c0,.93-.34,1.7-1.03,2.33-.66.59-1.47.89-2.41.89-1.61,0-2.75-.79-3.42-2.36l1.9-.88c.26.46.46.75.6.88.27.25.59.37.97.37.75,0,1.12-.34,1.12-1.03,0-.4-.29-.76-.87-1.11-.22-.11-.45-.22-.67-.33-.22-.1-.45-.21-.68-.32-.65-.32-1.1-.63-1.36-.95-.34-.4-.5-.92-.5-1.55,0-.83.29-1.52.86-2.07.58-.55,1.3-.82,2.13-.82,1.22.01,2.14.65,2.74,1.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.36,49.62v2.95c-.51-.62-.96-1.04-1.36-1.27-.39-.24-.86-.36-1.39-.36-.84,0-1.53.29-2.08.88s-.83,1.32-.83,2.2.27,1.64.8,2.22c.54.58,1.23.87,2.06.87.53,0,1-.11,1.41-.35.4-.22.86-.66,1.39-1.3v2.93c-.9.47-1.8.7-2.7.7-1.49,0-2.73-.48-3.73-1.44-1-.97-1.5-2.17-1.5-3.6s.51-2.64,1.52-3.63c1.01-.99,2.26-1.48,3.73-1.48.95,0,1.84.23,2.68.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.24,53.94c0-1.39.5-2.57,1.49-3.54s2.2-1.46,3.63-1.46,2.65.49,3.65,1.47c.99.98,1.48,2.18,1.48,3.61s-.5,2.65-1.49,3.62c-1,.97-2.23,1.45-3.68,1.45s-2.65-.49-3.62-1.48c-.98-.97-1.46-2.19-1.46-3.67ZM194.5,53.98c0,.96.26,1.72.77,2.28.53.57,1.22.85,2.08.85s1.56-.28,2.08-.84.78-1.3.78-2.24-.26-1.68-.78-2.24c-.53-.57-1.22-.85-2.08-.85s-1.54.28-2.06.85c-.52.57-.79,1.3-.79,2.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.12,51.28v7.54h-2.22v-7.54h-.95v-2.07h.95v-5.44h2.22v5.44h1.73v2.07h-1.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.83,43.77v15.05h-2.22v-15.05h2.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.78,49.21h2.23v9.61h-2.23v-1.01c-.91.85-1.9,1.28-2.95,1.28-1.33,0-2.43-.48-3.29-1.44-.86-.98-1.29-2.2-1.29-3.67s.43-2.64,1.29-3.6,1.94-1.44,3.24-1.44c1.12,0,2.12.46,3.01,1.38v-1.11s-.01,0-.01,0ZM217.51,53.98c0,.92.25,1.67.74,2.25.51.58,1.14.88,1.91.88.82,0,1.49-.28,1.99-.85.51-.58.76-1.33.76-2.23s-.25-1.64-.76-2.23c-.51-.57-1.16-.86-1.97-.86-.76,0-1.4.29-1.91.87-.5.59-.76,1.31-.76,2.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.88,49.21h2.23v.89c.78-.77,1.65-1.15,2.62-1.15,1.12,0,1.99.35,2.62,1.06.54.6.81,1.57.81,2.93v5.89h-2.23v-5.37c0-.95-.13-1.6-.4-1.96-.26-.37-.72-.55-1.4-.55-.74,0-1.26.24-1.57.73-.3.48-.45,1.32-.45,2.51v4.64h-2.23v-9.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.04,43.77h2.23v15.05h-2.23v-1.01c-.87.85-1.86,1.28-2.97,1.28-1.32,0-2.41-.48-3.27-1.44-.86-.98-1.29-2.2-1.29-3.67s.43-2.63,1.29-3.59c.85-.97,1.93-1.45,3.23-1.45,1.12,0,2.13.46,3.02,1.38v-6.55h0ZM240.77,53.98c0,.92.25,1.67.74,2.25.51.58,1.14.88,1.91.88.82,0,1.49-.28,1.99-.85.51-.58.76-1.33.76-2.23s-.25-1.64-.76-2.23c-.51-.57-1.16-.86-1.97-.86-.76,0-1.4.29-1.91.87-.5.59-.76,1.31-.76,2.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.13,13.3v6.72c-1.15-1.41-2.19-2.37-3.1-2.9-.9-.54-1.96-.81-3.17-.81-1.9,0-3.48.67-4.74,2-1.26,1.33-1.89,3-1.89,5.01s.61,3.74,1.82,5.06c1.23,1.32,2.79,1.98,4.7,1.98,1.21,0,2.28-.26,3.21-.79.9-.51,1.96-1.5,3.17-2.97v6.67c-2.05,1.06-4.11,1.6-6.16,1.6-3.39,0-6.22-1.09-8.5-3.28-2.28-2.2-3.42-4.94-3.42-8.2s1.15-6.02,3.46-8.27,5.14-3.37,8.5-3.37c2.16,0,4.2.52,6.12,1.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.03,23.15c0-3.16,1.13-5.85,3.39-8.07s5.02-3.33,8.27-3.33,6.04,1.12,8.32,3.35c2.25,2.23,3.37,4.97,3.37,8.23s-1.13,6.03-3.39,8.25c-2.28,2.2-5.07,3.3-8.38,3.3s-6.03-1.12-8.25-3.37c-2.22-2.22-3.33-5-3.33-8.36ZM106.2,23.24c0,2.19.58,3.92,1.75,5.19,1.2,1.29,2.78,1.93,4.74,1.93s3.56-.64,4.74-1.91,1.78-2.97,1.78-5.1-.59-3.83-1.78-5.1c-1.2-1.29-2.78-1.93-4.74-1.93s-3.5.64-4.7,1.93c-1.19,1.29-1.79,2.95-1.79,4.99Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.53,12.36h5.08v21.89h-5.08v-2.29c-2.08,1.95-4.32,2.92-6.72,2.92-3.03,0-5.53-1.09-7.51-3.28-1.96-2.23-2.94-5.02-2.94-8.36s.98-6.02,2.94-8.2c1.96-2.19,4.42-3.28,7.37-3.28,2.55,0,4.83,1.05,6.85,3.15v-2.55h0ZM132.53,23.24c0,2.1.56,3.81,1.69,5.12,1.15,1.33,2.61,2,4.36,2,1.87,0,3.39-.64,4.54-1.93,1.15-1.33,1.73-3.03,1.73-5.08s-.58-3.75-1.73-5.08c-1.15-1.3-2.65-1.96-4.5-1.96-1.74,0-3.19.66-4.36,1.98-1.15,1.34-1.73,2.99-1.73,4.95Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.81,0v34.25h-5.06V0h5.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.26,3.26c0-.88.32-1.65.97-2.29.64-.64,1.41-.97,2.31-.97s1.69.32,2.34.97c.64.63.97,1.4.97,2.32s-.32,1.69-.97,2.34c-.63.64-1.4.97-2.32.97s-1.69-.32-2.34-.97c-.64-.66-.96-1.44-.96-2.37ZM172.08,12.36v21.89h-5.06V12.36h5.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.66,17.08v17.17h-5.06v-17.17h-2.16v-4.72h2.16V4.34h5.06v8.02h3.93v4.72h-3.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,3.26c0-.88.32-1.65.97-2.29s1.41-.97,2.31-.97,1.69.32,2.34.97c.64.63.97,1.4.97,2.32s-.32,1.69-.97,2.34c-.63.64-1.4.97-2.31.97s-1.69-.32-2.34-.97c-.65-.66-.97-1.44-.97-2.37ZM198.01,12.36v21.89h-5.06V12.36h5.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,23.15c0-3.16,1.13-5.85,3.39-8.07s5.02-3.33,8.27-3.33,6.04,1.12,8.31,3.35c2.25,2.23,3.37,4.97,3.37,8.23s-1.13,6.03-3.39,8.25c-2.28,2.2-5.07,3.3-8.38,3.3s-6.03-1.12-8.25-3.37c-2.21-2.22-3.32-5-3.32-8.36ZM207.17,23.24c0,2.19.58,3.92,1.75,5.19,1.2,1.29,2.78,1.93,4.74,1.93s3.56-.64,4.74-1.91,1.77-2.97,1.77-5.1-.59-3.83-1.77-5.1c-1.2-1.29-2.78-1.93-4.74-1.93s-3.5.64-4.7,1.93c-1.19,1.29-1.79,2.95-1.79,4.99Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.41,12.36h5.08v2.02c1.77-1.75,3.76-2.63,5.98-2.63,2.55,0,4.53.8,5.96,2.4,1.23,1.36,1.84,3.59,1.84,6.68v13.42h-5.08v-12.22c0-2.16-.3-3.65-.9-4.47-.58-.84-1.65-1.26-3.19-1.26-1.68,0-2.87.55-3.57,1.66-.69,1.09-1.03,3-1.03,5.73v10.56h-5.08V12.36h0Z",
    style: {
      fill: "#fff"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "coc.svg";
export { ForwardRef as ReactComponent };